(function (window, document, $) {

    $(document).ready(function () {
        // SVG Mask stuff ==============================================================================================
        if (!themevars.restyling) { // When in restyling don't add svg's (after these lines)
            var $separators = $('.separator'),
                $listItems = $('.list-icon li'),
                $blockquotes = $('blockquote.content-quote');

            function inline_svg(url, $el, mode) {

                $.get(url, function (data) {
                    var $svg = $(data).find('svg'),
                        elID = $el.attr('id'),
                        elClass = $el.attr('class');

                    $el.css('background-image', 'none');

                    $svg.removeAttr('xmlns:a');
                    $svg.remove('title');

                    switch (mode) {
                        case 'prepend':
                            $el.addClass('prepend-svg');
                            $el.prepend($svg);
                            break;
                        case 'append':
                            $el.addClass('append-svg');
                            $el.append($svg);
                            break;
                        default:
                            if (typeof elID !== 'undefined') {
                                $svg.attr('id', elID);
                            }

                            if (typeof elClass !== 'undefined') {
                                $svg.attr('class', elClass + ' replaced-svg');
                            }

                            $el.replaceWith($svg);
                    }
                });
            }

            $separators.each(function (index, el) {
                var $el = $(el),
                    cssBackground = $el.css('background-image'),
                    svgURL = cssBackground.slice(4, -1).replace(/"/g, "");

                inline_svg(svgURL, $el, false);
            });

            /*$listItems.each(function (index, el) {
                var $el = $(el),
                    cssBackground = $el.css('background-image'),
                    svgURL = cssBackground.slice(4, -1).replace(/"/g, "");

                inline_svg(svgURL, $el, 'prepend');
            });*/

            // $blockquotes.each(function (index, el) {
            //     var $el = $(el),
            //         cssBackground = $el.css('background-image'),
            //         svgURL = cssBackground.slice(4, -1).replace(/"/g, "");

            //     inline_svg(svgURL, $el, 'append');
            // });
        }
    });

}(window, document, jQuery));
